import { QuestionType } from "generated/CoreApi_v1";

export const ALTERNATIVE_TRUE = 'T';
export const ALTERNATIVE_FALSE = 'F';
export const MAX_ALTERNATIVES = 7;
export const MAX_IA_ALTERNATIVES = 5;

export enum AddQuestionOptions {
    MultipleChoice = QuestionType.MultipleChoice,
    FillIn = QuestionType.FillInText,
    Essay = QuestionType.Essay,
    Star = QuestionType.Star,
}
